








import {Component, Emit, Prop, PropSync, Vue} from 'vue-property-decorator'
import VueJsonEditor from 'vue-json-editor'

@Component({
  components: {
    VueJsonEditor,
  }
})
export default class JsonEditor extends Vue {

  @PropSync('value') private valueSync!: unknown
  @Prop({default: '100%'}) private height!: string

  @Emit()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  change(newValue: {}) {
    // ignore
  }
}
